import {Navigate, Route, Routes} from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CustomersPage from './pages/CustomersPage';
import ServersPage from './pages/ServersPage';
import SitesPage from './pages/SitesPage';
import TemplatesPage from './pages/TemplatesPage';
import SiteEditorPage from './pages/SiteEditorPage';
import AiBuildPage from './pages/AiBuildPage';
import AgentPage, {AgentWorkspacePage} from './pages/AgentPage';
import {CatalogPage, PreviewVersionsPage, PublishPage, AdvancedSettingsPage} from './pages/WorkbenchPages';
import {AuthProvider, useAuth} from './lib/auth';
import AppLayout from './components/AppLayout';

function ProtectedRoute({children}: {children: React.ReactNode}) {
  const {token} = useAuth();
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <AppLayout>{children}</AppLayout>;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AgentPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent"
          element={
            <ProtectedRoute>
              <AgentPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent/sites/:siteId"
          element={
            <ProtectedRoute>
              <AgentWorkspacePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/catalog"
          element={
            <ProtectedRoute>
              <CatalogPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/versions"
          element={
            <ProtectedRoute>
              <PreviewVersionsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/publish"
          element={
            <ProtectedRoute>
              <PublishPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <AdvancedSettingsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers"
          element={
            <ProtectedRoute>
              <CustomersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/servers"
          element={
            <ProtectedRoute>
              <ServersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sites"
          element={
            <ProtectedRoute>
              <SitesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sites/:siteId/editor"
          element={
            <ProtectedRoute>
              <SiteEditorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sites/:siteId/ai-build"
          element={
            <ProtectedRoute>
              <AiBuildPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/templates"
          element={
            <ProtectedRoute>
              <TemplatesPage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
